import { FullScreenCard } from '@/components/card/FullScreenCard';
import { PageTitle } from '@/components/head/PageTitle';
import { AppShellContents } from '@/components/layout/AppShell';
import { TopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';
import { Card, CardBody, Typography } from '@statsbomb/kitbag-components';
import { MyPlaylists } from '@statsbomb/video-client-js';
import { useTranslation } from 'react-i18next';
import { hasVideoLicenceAtom } from '@/atoms/user';
import { useAtomValue } from 'jotai';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { StatusType } from '@/types/status';
import { AuthProtectedComponent } from '@statsbomb/kitbag-auth';
import { EmptyPlaylistContent } from '../components/video/EmptyPlaylistContent/EmptyPlaylistContent';

export const VideoPlaylists = () => {
  const { t } = useTranslation(['navigation', 'preferences', 'error']);
  const hasVideoLicence = useAtomValue(hasVideoLicenceAtom);

  return (
    <>
      <PageTitle>{t('primary.playlists')} </PageTitle>
      <AppShellContents
        topBar={
          <TopBar>
            <TopBarHeading>{t('primary.playlists')}</TopBarHeading>
          </TopBar>
        }
      >
        <FullScreenCard>
          <Card>
            {hasVideoLicence ? (
              <CardBody>
                <AuthProtectedComponent>
                  <MyPlaylists emptyStateContent={<EmptyPlaylistContent />} />
                </AuthProtectedComponent>
              </CardBody>
            ) : (
              <CardHeightWrapper>
                <CardBody
                  statusType={StatusType.error}
                  statusTitle={t('no_video_access.title', { ns: 'error' })}
                  statusDescription={
                    <Typography variant="bodyRegular">
                      {t('no_video_access.message', { ns: 'error' })}{' '}
                      <a className="underline" href="mailto:support@statsbomb.com">
                        {t('no_video_access.linkMessage', { ns: 'error' })}
                      </a>
                    </Typography>
                  }
                />
              </CardHeightWrapper>
            )}
          </Card>
        </FullScreenCard>
      </AppShellContents>
    </>
  );
};
